/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedChevronDown = createReactComponent(
  "square-rounded-chevron-down",
  "IconSquareRoundedChevronDown",
  [
    ["path", { d: "M15 11l-3 3l-3 -3", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedChevronDown as default };
//# sourceMappingURL=IconSquareRoundedChevronDown.js.map
